import { render, staticRenderFns } from "./BaoCaoKetQuaKinhDoanhCaNam.vue?vue&type=template&id=0336d77e&scoped=true"
import script from "./BaoCaoKetQuaKinhDoanhCaNam.vue?vue&type=script&lang=js"
export * from "./BaoCaoKetQuaKinhDoanhCaNam.vue?vue&type=script&lang=js"
import style0 from "./BaoCaoKetQuaKinhDoanhCaNam.vue?vue&type=style&index=0&id=0336d77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0336d77e",
  null
  
)

export default component.exports